import { FC, useState } from 'react'

import { App } from '../../typings/App'

import {
    Box,
    Drawer as MaterialDrawer,
    List,
    useTheme
} from '@mui/material'

import { AppItem } from '../AppItem'

interface Props {
    isOpen: boolean
    apps?: App[]
    onClose: () => void
}

export const Drawer: FC<Props> = ({
    isOpen,
    apps,
    onClose
}) => {
    const theme = useTheme()
    const [selectedItem, setSelectedItem] = useState<string | null>(null);
    const drawerWidth = theme.drawer.width
    const transition = theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: isOpen
            ? theme.transitions.duration.enteringScreen
            : theme.transitions.duration.leavingScreen
    })
    const drawerWidthValue = isOpen ? drawerWidth : 0

    return (
        <MaterialDrawer 
            variant="permanent" 
            sx={{
                width: drawerWidthValue,
                flexShrink: 0,
                transition
            }}
            PaperProps={{
                sx: {
                    width: drawerWidthValue,
                    overflowX: 'hidden',
                    transition,
                    [theme.breakpoints.up('sm')]: {
                        width: drawerWidthValue ? drawerWidth : 0
                    }
                }
            }}
            >
            <Box
                sx={{
                    p: theme.spacing(0, 1),
                    ...theme.mixins.toolbar
                }}
            />
            <List
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {
                    apps &&
                    apps.map((app) => (
                        <AppItem key={app.name} app={app} onCloseDrawer={onClose} selectedItem={selectedItem} onSelectItem={setSelectedItem}/>
                    ))
                }
            </List>
        </MaterialDrawer>
    )
}
